import { render, staticRenderFns } from "./FeedItem.vue?vue&type=template&id=01bce8ce&"
import script from "./FeedItem.vue?vue&type=script&lang=js&"
export * from "./FeedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports